// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const faShorten: CreateIconOptions = {
  "displayName": "FAShorten",
  "viewBox": "0, 0, 512, 512",
  "d": "M89.6 192c-7 0-12.8 5.8-12.8 12.8s5.8 12.8 12.8 12.8H422.4c7 0 12.8-5.8 12.8-12.8s-5.8-12.8-12.8-12.8H89.6zM76.8 307.2c0 7 5.8 12.8 12.8 12.8H294.4c7 0 12.8-5.8 12.8-12.8s-5.8-12.8-12.8-12.8H89.6c-7 0-12.8 5.8-12.8 12.8z"
};
